import { IDataEndPoint, IEntityEndPoints, IFieldOptions, IFormOptions, IGridOptions, IColumnOptions, IEntityOptions } from '@framework/interfaces/IEntity';
import * as app from '@framework/app';
import * as models from '@common/domain/models/AuditTrailDTO';
import { IApiServiceCommand } from '@services/api/api.service';
export class AuditTrailEndPoints implements IEntityEndPoints {
	list?: IDataEndPoint = { url: function (serviceCommand: IApiServiceCommand): string { return app.config.controllerRouteRoot + "/auditTrail"}, method: "GET" };
	get?: IDataEndPoint = { url: function (serviceCommand: IApiServiceCommand): string { return app.config.controllerRouteRoot + "/auditTrail/" + serviceCommand.context.entityId}, method: "GET" };
	update?: IDataEndPoint = { url: function (serviceCommand: IApiServiceCommand): string { return app.config.controllerRouteRoot + "/auditTrail/update/" + serviceCommand.context.entityId}, method: "POST" };
	search?: IDataEndPoint = { url: function (serviceCommand: IApiServiceCommand): string { return app.config.controllerRouteRoot + "/auditTrail/lazy/"}, method: "POST" };
	pagingTotalCount?: IDataEndPoint = { url: function (serviceCommand: IApiServiceCommand): string { return app.config.controllerRouteRoot + "/auditTrail/lazyCount/"}, method: "POST" };
	insert?: IDataEndPoint = { url: function (serviceCommand: IApiServiceCommand): string { return app.config.controllerRouteRoot + "/auditTrail/create"}, method: "POST" };
	delete?: IDataEndPoint = { url: function (serviceCommand: IApiServiceCommand): string { return app.config.controllerRouteRoot + "/auditTrail/delete/"+ serviceCommand.context.entityId}, method: "POST" };
}

export class AuditTrailFormFields extends Array<IFieldOptions> {
	public id: IFieldOptions = { field: "id" };
	public deleteAction: IFieldOptions = { field: "deleteAction" };
	public updateAction: IFieldOptions = { field: "updateAction" };
	public createAction: IFieldOptions = { field: "createAction" };
	public columnDataType: IFieldOptions = { field: "columnDataType" };
	public columnName: IFieldOptions = { field: "columnName" };
	public newValue: IFieldOptions = { field: "newValue" };
	public oldValue: IFieldOptions = { field: "oldValue" };
	public primaryKeyName: IFieldOptions = { field: "primaryKeyName" };
	public primaryKeyValue: IFieldOptions = { field: "primaryKeyValue" };
	public tableName: IFieldOptions = { field: "tableName" };
	public userId: IFieldOptions = { field: "userId" };
	public datestamp: IFieldOptions = { field: "datestamp" };
	public auditType: IFieldOptions = { field: "auditType" };
	public auditTypeIdentifier: IFieldOptions = { field: "auditTypeIdentifier" };
	public auditTrailCommentId: IFieldOptions = { field: "auditTrailCommentId" };
	constructor() {
		super();
		this.push(this.id);
		this.push(this.deleteAction);
		this.push(this.updateAction);
		this.push(this.createAction);
		this.push(this.columnDataType);
		this.push(this.columnName);
		this.push(this.newValue);
		this.push(this.oldValue);
		this.push(this.primaryKeyName);
		this.push(this.primaryKeyValue);
		this.push(this.tableName);
		this.push(this.userId);
		this.push(this.datestamp);
		this.push(this.auditType);
		this.push(this.auditTypeIdentifier);
		this.push(this.auditTrailCommentId);
	}
}

export class AuditTrailForm implements IFormOptions {
	protected auditTrailFormName: string = "auditTrailForm";
	protected auditTrailFormModel: models.AuditTrailDTO = new models.AuditTrailDTO();
	protected auditTrailFormEndPoints: AuditTrailEndPoints = new AuditTrailEndPoints();
	protected auditTrailFormFields: AuditTrailFormFields = new AuditTrailFormFields();
	public get name(): string { return this.auditTrailFormName };
	public get model(): models.AuditTrailDTO { return this.auditTrailFormModel };
	public get endPoints(): IEntityEndPoints { return this.auditTrailFormEndPoints };
       public set endPoints(auditTrailEndPoints: IEntityEndPoints) {
		this.auditTrailFormEndPoints = auditTrailEndPoints;
	};
	public get dataEndPoint(): IDataEndPoint { return this.endPoints.get };
	public get fields(): AuditTrailFormFields { return this.auditTrailFormFields };
}

export class AuditTrailListColumns extends Array<IColumnOptions> {
	public id: IColumnOptions = { field: "id" };
	public deleteAction: IColumnOptions = { field: "deleteAction" };
	public updateAction: IColumnOptions = { field: "updateAction" };
	public createAction: IColumnOptions = { field: "createAction" };
	public columnDataType: IColumnOptions = { field: "columnDataType" };
	public columnName: IColumnOptions = { field: "columnName" };
	public newValue: IColumnOptions = { field: "newValue" };
	public oldValue: IColumnOptions = { field: "oldValue" };
	public primaryKeyName: IColumnOptions = { field: "primaryKeyName" };
	public primaryKeyValue: IColumnOptions = { field: "primaryKeyValue" };
	public tableName: IColumnOptions = { field: "tableName" };
	public userId: IColumnOptions = { field: "userId" };
	public datestamp: IColumnOptions = { field: "datestamp", template: function (fldValue) { return (new Date(fldValue)["shortDate"]()).toString(); } };
	public auditType: IColumnOptions = { field: "auditType" };
	public auditTypeIdentifier: IColumnOptions = { field: "auditTypeIdentifier" };
	public auditTrailCommentId: IColumnOptions = { field: "auditTrailCommentId" };
	constructor() {
		super();
		this.push(this.id);
		this.push(this.deleteAction);
		this.push(this.updateAction);
		this.push(this.createAction);
		this.push(this.columnDataType);
		this.push(this.columnName);
		this.push(this.newValue);
		this.push(this.oldValue);
		this.push(this.primaryKeyName);
		this.push(this.primaryKeyValue);
		this.push(this.tableName);
		this.push(this.userId);
		this.push(this.datestamp);
		this.push(this.auditType);
		this.push(this.auditTypeIdentifier);
		this.push(this.auditTrailCommentId);
	}
}

export class AuditTrailList implements IGridOptions {
	protected auditTrailListName: string = "auditTrailList";
	protected auditTrailListModel: models.AuditTrailDTO = new models.AuditTrailDTO();
	protected auditTrailListEndPoints: AuditTrailEndPoints = new AuditTrailEndPoints();
	protected auditTrailListColumns: AuditTrailListColumns = new AuditTrailListColumns();
	public auditTrailForm: AuditTrailForm = new AuditTrailForm();
	public get name(): string { return this.auditTrailListName };
	public get model(): models.AuditTrailDTO { return this.auditTrailListModel };
	public get endPoints(): IEntityEndPoints { return this.auditTrailListEndPoints };
	public set endPoints(auditTrailEndPoints: IEntityEndPoints) {
		this.auditTrailListEndPoints = auditTrailEndPoints;
		this.auditTrailForm.endPoints = this.endPoints;
	};
	public get dataEndPoint(): IDataEndPoint { return this.endPoints.list };
	public get columns(): AuditTrailListColumns { return this.auditTrailListColumns };
}

export class AuditTrailEntity implements IEntityOptions {
	protected auditTrailEntityName: string = "auditTrailEntity";
	protected auditTrailEntityModel: models.AuditTrailDTO = new models.AuditTrailDTO();
	protected auditTrailEntityEndPoints: AuditTrailEndPoints = new AuditTrailEndPoints();
	protected auditTrailEntityList: AuditTrailList = new AuditTrailList();
	public get name(): string { return this.auditTrailEntityName };
	public get model(): models.AuditTrailDTO { return this.auditTrailEntityModel };
	public get endPoints(): IEntityEndPoints { return this.auditTrailEntityEndPoints };
	public set endPoints(auditTrailEndPoints: IEntityEndPoints) {
		this.auditTrailEntityEndPoints = auditTrailEndPoints;
		this.grid.endPoints = this.endPoints;
	};
	public get grid(): AuditTrailList { return this.auditTrailEntityList };
	public get form(): AuditTrailForm { return this.grid.auditTrailForm };
	constructor(name?: string) {
		if (name) this.auditTrailEntityName = name;
		this.endPoints = this.auditTrailEntityEndPoints;
	}
};
//export class AuditTrailGeneratedForm extends MfGeneratedFormComponent {
 // protected detailPageComponentForm: AuditTrailForm = new AuditTrailForm();
//};

//export class AuditTrailListPageComponent extends ListPageComponent {
  //protected listPageComponentList: AuditTrailList = new  AuditTrailList();
  //protected showFilterColOnTable: boolean = true;
//};

//export class AuditTrailBlade extends MfBladeComponent {
  //protected detailComponents: Array<IDetailComponent> = [ { index: 0, displayName: "Properties", component: AuditTrailGeneratedForm}];
//};

//export class AuditTrailListBlade extends MfBladeComponent {
 // protected detailComponents: Array<IDetailComponent> = [ { index: 0, displayName: "Properties", component: AuditTrailListPageComponent, isMenuHidden: true }];
//};

